import { AXIOS_INSTANCE } from '@metaonia/api-client';

import type { UserProfile } from '@metaonia/shared';

let accessToken: string | null = null;
let refreshToken: string | null = null;

function getRedirectUri(): string {
  const base = import.meta.env.BASE_URL ?? '/';
  return `${window.location.origin}${base}auth/callback`;
}

export function getSsoAccessToken(): string | null {
  return accessToken;
}

export async function ssoRedirect(domain: string): Promise<void> {
  const response = await AXIOS_INSTANCE.post('/auth/sso/init', {
    org_domain: domain,
    redirect_uri: getRedirectUri(),
  });

  const { redirect_url } = response.data.data;
  window.location.href = redirect_url;
}

export async function ssoHandleCallback(
  code: string,
  state: string,
): Promise<{ user: UserProfile; access_token: string; refresh_token: string }> {
  const response = await AXIOS_INSTANCE.post('/auth/sso/callback', {
    code,
    state,
    redirect_uri: getRedirectUri(),
  });

  const { access_token, refresh_token: rt, user } = response.data.data;
  accessToken = access_token;
  refreshToken = rt;
  sessionStorage.setItem('metaonia_refresh_token', rt);

  return { user, access_token, refresh_token: rt };
}

export async function ssoRefreshTokens(): Promise<void> {
  const stored = refreshToken ?? sessionStorage.getItem('metaonia_refresh_token');
  if (!stored) throw new Error('No refresh token');

  const response = await AXIOS_INSTANCE.post('/auth/refresh', {
    refresh_token: stored,
  });

  accessToken = response.data.data.access_token;
  refreshToken = response.data.data.refresh_token;
  sessionStorage.setItem('metaonia_refresh_token', response.data.data.refresh_token);
}

export function ssoLogout(): void {
  accessToken = null;
  refreshToken = null;
  sessionStorage.removeItem('metaonia_refresh_token');
}

export function restoreSsoSession(): boolean {
  const stored = sessionStorage.getItem('metaonia_refresh_token');
  if (stored) {
    refreshToken = stored;
    return true;
  }
  return false;
}
